
import { useState, useEffect } from "react";
import axios from "axios";
import { branding } from "../../config";

export default function NewsletterFormPublic() {
    const [emailListId, setEmailListId] = useState(null);
    const [headerText, setHeaderText] = useState("Join Our Newsletter");
    const [descriptionText, setDescriptionText] = useState("Stay updated with the latest news and events from the Garden Club of the Eastern Shore");
    const [email, setEmail] = useState("");
    const [name, setName] = useState("");
    const [loading, setLoading] = useState(true);
    const [submitting, setSubmitting] = useState(false);
    const [submitted, setSubmitted] = useState(false);
    const [submitMessage, setSubmitMessage] = useState("");
    const [submitSuccess, setSubmitSuccess] = useState(false);

    useEffect(() => {
        fetchNewsletterConfig();
    }, []);

    const fetchNewsletterConfig = async () => {
        try {
            const res = await axios.get("/api/public/newsletter");
            const listId = res.data.content?.email_list_id;
            const header = res.data.content?.header_text;
            const description = res.data.content?.description_text;
            
            // Only set if there's actually a newsletter configured (not empty string)
            if (listId && listId.trim()) {
                setEmailListId(listId);
                
                // Set custom texts if they exist
                if (header && header.trim()) {
                    setHeaderText(header);
                }
                if (description && description.trim()) {
                    setDescriptionText(description);
                }
            }
        } catch (error) {
            console.error("Error fetching newsletter config:", error);
        } finally {
            setLoading(false);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        if (!email.trim()) {
            setSubmitMessage("Email address is required");
            setSubmitSuccess(false);
            setSubmitted(true);
            return;
        }

        setSubmitting(true);
        try {
            await axios.post(`/api/emails/${emailListId}/join`, {
                email: email.trim(),
                name: name.trim() || "Newsletter Subscriber"
            });
            
            setSubmitMessage("Successfully joined the newsletter! Thank you for subscribing.");
            setSubmitSuccess(true);
            setSubmitted(true);
        } catch (error) {
            if (error.response?.status === 400 && error.response?.data?.detail?.includes("already")) {
                setSubmitMessage("You're already subscribed to this newsletter!");
                setSubmitSuccess(true); // Treat as success since they're already subscribed
            } else {
                setSubmitMessage("Failed to join newsletter. Please try again later.");
                setSubmitSuccess(false);
            }
            setSubmitted(true);
        } finally {
            setSubmitting(false);
        }
    };

    if (loading) {
        return null; // Don't show anything while loading
    }

    if (!emailListId) {
        return null; // Don't show form if no newsletter is configured
    }

    return (
        <section
            style={{
                marginTop: "0px",
                background: `linear-gradient(135deg, ${branding.primaryColor} 0%, ${branding.secondaryColor || '#004466'} 100%)`,
                // backgroundColor: "#025387",
                padding: "60px 20px",
                fontFamily: "'Montserrat', sans-serif",
                color: "white"
            }}
        >
            <div
                style={{
                    maxWidth: "600px",
                    margin: "0 auto",
                    textAlign: "center",
                }}
            >
                <h2
                    style={{
                        fontWeight: "700",
                        marginBottom: "20px",
                        // textTransform: "uppercase",
                        letterSpacing: "1px",
                        fontSize: "3rem"
                    }}
                >
                    {headerText}
                </h2>
                
                {submitted ? (
                    // Show message after submission
                    <div
                        style={{
                            padding: "30px",
                            borderRadius: "12px",
                            backgroundColor: submitSuccess ? "white" : "white",
                            border: `2px solid ${submitSuccess ? "white" : "white"}`,
                            marginTop: "20px"
                        }}
                    >
                        <h4
                            style={{
                                color: submitSuccess ? "#2f5c39" : "#dc3545",
                                marginBottom: "10px",
                                fontWeight: "600"
                            }}
                        >
                            {submitSuccess ? "✓ Success!" : "✗ Error"}
                        </h4>
                        <p
                            style={{
                                color: submitSuccess ? "#2f5c39" : "#dc3545",
                                fontSize: "1.1rem",
                                margin: 0,
                                fontWeight: "500"
                            }}
                        >
                            {submitMessage}
                        </p>
                    </div>
                ) : (
                    // Show form before submission
                    <>
                        <p
                            style={{
                                fontSize: "1.3rem",
                                marginBottom: "30px",
                                opacity: 0.9
                            }}
                        >
                            {descriptionText}
                        </p>
                        
                        <form onSubmit={handleSubmit} className="row g-3 justify-content-center">
                            <div className="col-md-5">
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Your name (optional)"
                                    value={name}
                                    onChange={(e) => setName(e.target.value)}
                                    style={{
                                        borderRadius: "8px",
                                        border: "none",
                                        padding: "12px 16px"
                                    }}
                                />
                            </div>
                            <div className="col-md-5">
                                <input
                                    type="email"
                                    className="form-control"
                                    placeholder="Your email address"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    required
                                    style={{
                                        borderRadius: "8px",
                                        border: "none",
                                        padding: "12px 16px"
                                    }}
                                />
                            </div>
                            <div className="col-md-2">
                                <button
                                    type="submit"
                                    className="btn btn-custom-filled-light w-100"
                                    disabled={submitting}
                                    style={{
                                        borderRadius: "8px",
                                        padding: "12px 16px",
                                        fontWeight: "600"
                                    }}
                                >
                                    {submitting ? "Joining..." : "Join"}
                                </button>
                            </div>
                        </form>
                    </>
                )}
            </div>
        </section>
    );
}